import { Field, useFormikContext } from "formik";

const FormInput = ({ name, touched, errors, ...rest }: any) => {

  return (
    <Field
      name={name}
      error={errors[name] && touched[name] ? true : false}
      helperText={errors[name]}
      {...rest}
    />
  );
};

export default FormInput;
